import React from 'react';

import CustomIcon from '../Common/CustomIcon/CustomIcon';
import ChonkyFileBrowser, {
	renderFolderIcon,
} from './Chonky/ChonkyFileBrowser';

import  {
	formatBytes,
	getFilePath,
	VALID_EXTENSIONS,
	validateFiles,
} from './Chonky/lib';

import DatePicker from 'react-datepicker';

// Styles
import style from './Slideshow.module.css';
import 'react-datepicker/dist/react-datepicker.css';

import {
	buildTestData,
} from 'Vulture/TestData';
import Img from 'wrapper/Img';

import {
    vultureENV,
} from 'Vulture/ENV.js';
import { s3 } from 'S3';
import { downloadFile, safeDecode } from './utils/downloadFile';
import {
	formatTimeForPicker,
	handleStartTimeChange,
	handleEndTimeChange,
	formatDateForJSON,
	formateDateForDatePicker,
	dayMap,
	timePickerProps,
	WeekdaySelector,
	getInitialSchedulingMode,
	cleanSchedulingData,
	getSchedulingModeDisplayText,
	getSchedulingPlaceholderStyle,
	SchedulingHelperText,
} from './utils/scheduling';
import { s3PublicURL } from 'Vulture/S3.js';
import {
	isValidURLSlideURL,
	URL_SLIDE_MAX_LENGTH,
} from './utils/slides';


const basePreviewSrc = 'https://ts-pelican-resized.s3.amazonaws.com/y9DpT.jpg';
const videoPreviewSrc = 'https://ts-pelican-resized.s3.amazonaws.com/video_placeholder.jpeg';

const sizeLimits = {
	'image/*': {
		size: 10,
		unit: 'mb',
	},
	'video/*': {
		size: 400,
		unit: 'mb',
	},
};

class SlideModal extends React.Component {
	constructor(props) {
		super(props);

		let initialSchedulingMode = getInitialSchedulingMode(props.slideData?.scheduling);

		this.state = {
			isLibrarySelection: !!props.slideData?.isLibrarySelection,
			folderID:           props.slideData?.folderID || null,
			galleryFileID:      props.slideData?.galleryFileID || null,
			slideID:            props.slideData?.slideID || null,
			duration:           props.slideData?.duration || 15,
			order:              props.slideData?.order || 1,
			folderSlots:        props.slideData?.folderSlots || 1,
			filePath:           props.slideData?.file || props.slideData?.filePath || '',
			fileName:           props.slideData?.file_name || '',
			kind:               props.slideData?.kind || '',
			description:        props.slideData?.description || '',
			resolution:         props.slideData?.resolution || '',
			fileSize:           props.slideData?.file_size || 0,
			tags:               [],
			previewSrc:         safeDecode(props.slideData?.src) || basePreviewSrc,
			scheduled:          props.slideData?.scheduled || false,
			scheduling:         {
				days:                   [],
				start_date:             null,
				end_date:               null,
				start_time:             null,
				end_time:               null,
				recurring_start_time:   null,
				recurring_end_time:     null,
				recurring_times_by_day: {},
				...(props.slideData?.scheduling || {}),
			},
			schedulingMode:             initialSchedulingMode,
			schedulingModeDropdownOpen: false,
			durationButtonClass:        (props.slideData?.kind || '').startsWith('video') ? 'button-disabled no-click' : 'button',
			confirmModal:               false,
			confirmModalContent:        null,
			file:                       null,
			modalState:                 'slide',
		};

		this.isSaving = false;
		this.schedulingModeDropdownRef = React.createRef();
		this.schedulingSectionRef = React.createRef();
		this.timeRangesByDayRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	async startDownloadClicked(url, fileName, onProgress = () => {}) {
		try {
			await downloadFile(url, fileName, onProgress);
			return true;
		} catch (err) {
			alert(err && (err.status === 403 || err.status === 404) ?
				'File not found. Please contact the administrator.' :
				'Download failed.');
			return false;
		}
	}



	handleClickOutside = (event) => {
		if (this.schedulingModeDropdownRef.current && !this.schedulingModeDropdownRef.current.contains(event.target)) {
			this.setState({
				schedulingModeDropdownOpen: false,
			});
		}
	}

	toggleSchedulingModeDropdown = () => {
		this.setState((prevState) => {
			return {
				schedulingModeDropdownOpen: !prevState.schedulingModeDropdownOpen,
			};
		});
	}

	handleSelectGalleryFile(galleryFile) {
		if (this.props.isEdit) {
			this.setState({
				replacedFile: true,
			});
		}
		const previewSrc = safeDecode(galleryFile.previewURL) || galleryFile.previewURL;

		let splitName = galleryFile.name.split('.');
		let extension = splitName[splitName.length - 1];

		const videoExtensions = [ 'mp4', 'webm', ];
		const isVideo = videoExtensions.includes(extension);

		let duration = galleryFile.duration;

				if (isVideo) {
					if (!duration) {
						const video = document.createElement('video');
						video.preload = 'metadata';
						video.crossOrigin = 'anonymous';
						video.style.display = 'none';
						document.body.appendChild(video);

						const handleLoadedMetadata = () => {
							this.setState({
								previewSrc,
								kind:                `video/${extension}`,
								fileName:            galleryFile.name,
								duration:            video.duration,
								folderSlots:         1,
								description:         galleryFile.name,
								resolution:          galleryFile.resolution,
								filePath:            safeDecode(galleryFile.imgKey) || galleryFile.imgKey,
								fileSize:            galleryFile.size,
								isLibrarySelection:  true,
								galleryFileID:       Number(galleryFile.fileID.replace('file_', '')),
								folderID:            null,
								modalState:          'slide',
								durationButtonClass: 'button-disabled no-click',
							});

							try {
								video.removeEventListener('loadedmetadata', handleLoadedMetadata);
								video.removeEventListener('error', handleError);
							} catch (e) {}
							if (video.parentNode) video.parentNode.removeChild(video);
						};

						const handleError = () => {
							try {
								video.removeEventListener('loadedmetadata', handleLoadedMetadata);
								video.removeEventListener('error', handleError);
							} catch (e) {}
							if (video.parentNode) video.parentNode.removeChild(video);
						};

						video.addEventListener('loadedmetadata', handleLoadedMetadata, { once: true });
						video.addEventListener('error', handleError, { once: true });

						const bucketsToTry = [ 'ts-pelican', 'ts-condor-assets' ];
						const prefixes = [ 'ciprod', 'citest', 'dev', 'stage' ];
						let bareKey = safeDecode(galleryFile.imgKey) || galleryFile.imgKey;
						const maybeMatch = galleryFile.imgKey && (safeDecode(galleryFile.imgKey) || galleryFile.imgKey).match(/^(ciprod|citest|dev|stage)\/(.+)$/);
						if (maybeMatch) bareKey = maybeMatch[2];
						const candidateKeys = [ safeDecode(galleryFile.imgKey) || galleryFile.imgKey ];
						prefixes.forEach((p) => {
							const k = `${p}/${bareKey}`;
							if (!candidateKeys.includes(k)) candidateKeys.push(k);
						});
						let bi = 0, ki = 0;
						const tryNextSrc = () => {
							if (bi >= bucketsToTry.length) { video.src = getFilePath(safeDecode(galleryFile.imgKey) || galleryFile.imgKey); return; }
							if (ki >= candidateKeys.length) { bi += 1; ki = 0; return tryNextSrc(); }
							const params = { Bucket: bucketsToTry[bi], Key: candidateKeys[ki] };
							s3.headObject(params, (hErr, data) => {
								if (!hErr && data) {
									s3.getSignedUrl('getObject', params, (gErr, signedUrl) => {
										if (!gErr && signedUrl) {
											video.src = signedUrl;
										} else {
											video.src = getFilePath(safeDecode(galleryFile.imgKey) || galleryFile.imgKey);
										}
									});
								} else {
									ki += 1; tryNextSrc();
								}
							});
						};
						tryNextSrc();
					} else {
				this.setState({
					previewSrc,
					kind:                `video/${extension}`,
					fileName:            galleryFile.name,
					duration:            galleryFile.duration,
					folderSlots:         1,
					description:         galleryFile.name,
					resolution:          galleryFile.resolution,
					filePath:            safeDecode(galleryFile.imgKey) || galleryFile.imgKey,
					fileSize:            galleryFile.size,
					isLibrarySelection:  true,
					galleryFileID:       Number(galleryFile.fileID.replace('file_', '')),
					folderID:            null,
					modalState:          'slide',
					durationButtonClass: 'button-disabled no-click',
				});
			}
		} else {
			this.setState({
				previewSrc,
				kind:                `image/${extension}`,
				fileName:            galleryFile.name,
				description:         galleryFile.description,
				resolution:          galleryFile.resolution,
				filePath:            safeDecode(galleryFile.imgKey) || galleryFile.imgKey,
				fileSize:            galleryFile.size,
				isLibrarySelection:  true,
				galleryFileID:       Number(galleryFile.fileID.replace('file_', '')),
				folderID:            null,
				modalState:          'slide',
				durationButtonClass: 'button',
			});
		}
	}

	handleSelectFolder(folder) {
		if (this.props.isEdit) {
			this.setState({
				replacedFile: true,
			});
		}
		this.setState({
			previewSrc:          basePreviewSrc, // should be folderlike image
			kind:                'folder',
			fileName:            folder.name,
			description:         folder.name,
			resolution:          '-',
			filePath:            '-',
			fileSize:            '-',
			isLibrarySelection:  true,
			galleryFileID:       null,
			folderID:            Number(folder.id.replace('node_', '')),
			modalState:          'slide',
			durationButtonClass: 'button',
		});
	}

	handleImageUpload(e) {
		const {
			accountUUID,
		} = this.props;

		e.preventDefault();
		if (!(e.target && e.target.files)) {
			return;
		}

		const selectedFiles = Array.from(e.target.files);
		const {
			validFiles,
			invalidFiles,
		} = validateFiles(selectedFiles);

		if (invalidFiles.length > 0) {
			const invalidNames = invalidFiles.map((file) => {
				return file.name;
			}).join(', ');
			const validExtensions = VALID_EXTENSIONS.join(', ');
			alert(`The uploaded file has an unsupported format and will be skipped: ${invalidNames}\n\nSupported formats: ${validExtensions}`);
			return;
		}

		const file = validFiles[0];
		const fileType = file.type;

		let goodSize = true;
		Object.keys(sizeLimits).forEach((key) => {
			let fileSize = file.size;
			let typeSegments = fileType.split('/');
			let sizeSegments = key.split('/');
			if (typeSegments[0] !== sizeSegments[0]) {
				return;
			}
			if (typeSegments[1] === sizeSegments[1] || sizeSegments[1] === '*') {
				let ruleUnit = sizeLimits[key].unit;
				let ruleSize = Number(sizeLimits[key].size + 1);
				if (ruleUnit === 'mb') {
					fileSize = fileSize / 1024 / 1024;
				}
				if (ruleUnit === 'kb') {
					fileSize = fileSize / 1024;
				}

				if (fileSize > ruleSize) {
					this.setState({
						confirmModal:        true,
						confirmModalContent:
							<>
								<p>{'File size: ' + Math.floor(fileSize) + '(' + ruleUnit + ') is too large for file type.'}</p>
								<div className="confirm-modal-buttons">
									<button className="button" onClick={(e) => {
										this.setState({
											confirmModal: false,
										});
									}}>Okay</button>
								</div>
							</>,
					});
					goodSize = false;
				}
			}
		});

		if (!goodSize) {
			return;
		}

		let fileArray = fileType.split('/');
		let type = fileArray[0];

		let previewSrc = basePreviewSrc;
		if (type === 'image') {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (_e) => {
				const image = new Image();
				image.src = reader.result;
				image.onload = () => {
					previewSrc = _e.target.result;

					const replacementFlag = !!this.props.isEdit;

					this.setState({
						isLibrarySelection:  false,
						previewSrc,
						kind:                fileType,
						description:         file.name,
						fileName:            file.name,
						resolution:          `${image.width}x${image.height}`,
						filePath:            file.name,
						fileSize:            file.size,
						file,
						durationButtonClass: 'button',
						replacedFile:        replacementFlag,
					});
				};
			};
		} else {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (_e) => {
				const video = document.createElement('video');
				video.preload = 'metadata';
				video.crossOrigin = 'anonymous';
				video.style.display = 'none';
				document.body.appendChild(video);
				video.src = _e.target.result;

				video.addEventListener('loadedmetadata', () => {
					// Set current time to a small value to ensure we get a frame
					video.currentTime = 0.1;
				});

				video.addEventListener('seeked', () => {
					const replacementFlag = !!this.props.isEdit;

					// Capture the first frame as preview
					const canvas = document.createElement('canvas');
					canvas.width = video.videoWidth;
					canvas.height = video.videoHeight;
					const ctx = canvas.getContext('2d');

					// Draw the first frame to canvas
					ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
					previewSrc = canvas.toDataURL('image/jpeg', 0.8);

					// Clean up the video element
					document.body.removeChild(video);

					this.setState({
						isLibrarySelection:  false,
						previewSrc,
						kind:                fileType,
						description:         file.name,
						fileName:            file.name,
						resolution:          `${video.videoWidth}x${video.videoHeight}`,
						duration:            video.duration,
						folderSlots:         1,
						filePath:            file.name,
						fileSize:            file.size,
						file,
						durationButtonClass: 'button-disabled no-click',
						replacedFile:        replacementFlag,
					});
				});
			};
		}
	}

	save = async () => {
		const {
			isEdit,
		} = this.props;

		const {
			folderID,
			galleryFileID,
			isLibrarySelection,
			duration,
			order,
			folderSlots,
			filePath,
			file,
			fileName,
			fileSize,
			description,
			kind,
			scheduled,
			scheduling,
			resolution,
			schedulingMode,
		} = this.state;

		let modeToSave = schedulingMode;
		if (!scheduled) {
			modeToSave = '';
		}

		// Clean up scheduling data based on active mode
		const cleanedScheduling = cleanSchedulingData(scheduling, scheduled, modeToSave);

		// URL slides (kind 'html') store the URL in filePath and are rendered in a
		// sandboxed iframe on the kiosk, so https is mandatory — same rule as
		// SlideshowModal.
		if (kind === 'html' && !isValidURLSlideURL(filePath)) {
			this.setState({
				confirmModal:        true,
				confirmModalContent:
					<>
						<p>{`You must input a valid HTTPS URL (max ${URL_SLIDE_MAX_LENGTH} characters) in order to continue saving.`}</p>
						<div className="confirm-modal-buttons">
							<button className="button" onClick={(e) => {
								this.setState({
									confirmModal: false,
								});
							}}>Okay</button>
						</div>
					</>,
			});
			this.isSaving = false;
			return;
		}

		if (!isEdit) {
			const newSlideData = {
				folderID,
				galleryFileID,
				duration,
				order,
				folderSlots,
				filePath,
				file,
				kind,
				fileName,
				fileSize,
				description,
				scheduled,
				scheduling: cleanedScheduling,
				resolution,
			};

			await this.props.addSlide(newSlideData, isLibrarySelection);

			this.setState({
				replacedFile: false,
			});
		} else {
			const {
				slideData,
			} = this.props;

			const updatedSlideData = {
				...slideData,
				folderID,
				galleryFileID,
				duration,
				order,
				folderSlots,
				filePath,
				file,
				kind,
				fileName,
				fileSize,
				description,
				scheduled,
				scheduling:   cleanedScheduling,
				resolution,
				replacedFile: !!this.state.replacedFile,
			};

			await this.props.editSlide(updatedSlideData, isLibrarySelection);

			this.setState({
				replacedFile: false,
			});
		}

		this.isSaving = false;
	}


	openConfirmDownload = (url, fileName) => {
		this.setState({
			confirmModal: true,
			confirmModalContent: (
				<>
					<p>Would you like to download this file?</p>
					<div className="confirm-modal-buttons">
						<button className="button-outlined" onClick={async (e) => {
							e.stopPropagation();
							this.setState({
								confirmModal:     false,
								downloading:      true,
								downloadProgress: 0,
							});
							const onProgress = (p) => {
								this.setState({ downloadProgress: p });
							};

							await this.startDownloadClicked(url, fileName, onProgress);

							this.setState({ downloading: false, downloadProgress: 0 });
						}}>Yes</button>
						<button className="button" onClick={() => { this.setState({ confirmModal: false }); }}>No</button>
					</div>
				</>
			),
		});
	};

	updateDays(day) {
		const {
			scheduling,
			schedulingMode,
		} = this.state;

		const isAdding = !(scheduling.days || []).includes(day);
		let days = scheduling.days || [];
		if (days.includes(day)) {
			days.map((obj, i) => {
				if (obj === day) {
					days.splice(i, 1);
				}
			});
		} else {
			days.push(day);
		}

		scheduling.days = days.sort((a, b) => {
			return a - b;
		});
		this.setState({
			scheduling,
		}, () => {
			if (isAdding && schedulingMode === 'specific-days-with-times' && this.timeRangesByDayRef.current) {
				this.timeRangesByDayRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		});
	}

	render() {
		const {
			isEdit,
			allowSlideshowUrl,
			app,
			slideData,
		} = this.props;

		const {
			duration,
			order,
			folderSlots,
			filePath,
			fileName,
			kind,
			description,
			scheduled,
			scheduling,
			resolution,
			fileSize,
			// tags,
			previewSrc,
			durationButtonClass,
			modalState,
			confirmModal,
			confirmModalContent,
			isLibrarySelection,
			file,
			schedulingMode,
		} = this.state;

		let disabledForEdit = 'button';
		// let disabledForAdd = "button";

		if (isEdit) {
			disabledForEdit = 'button button-disabled no-click button-hide';
		}

		const isURLSlide = modalState === 'url' || kind === 'html';
		const saveDisabled = !this.isSaving && !isEdit && !isLibrarySelection && !file && !(isURLSlide && (filePath || '').trim());

		const rawKey = filePath || slideData?.path || '';
		const downloadKey = safeDecode(rawKey) || rawKey;
		const originalURL = downloadKey ? s3PublicURL('ts-condor-assets', `${vultureENV}/ts-library/${downloadKey}`) : '';
		const downloadFileName = fileName || (downloadKey ? downloadKey.split('/').pop() : '');

		let bottomButton =
			<button
				onClick={(e) => {
					this.setState({
						confirmModal:        true,
						confirmModalContent:
							<>
								<p>By cancelling you will lose your unsaved changes. Are you sure you want to continue?</p>
								<div className="confirm-modal-buttons">
									<button className="button-outlined" onClick={(e) => {
										this.setState({
											confirmModal: false,
										});
										app.closeModal();
									}}>Yes</button>
									<button className="button" onClick={(e) => {
										this.setState({
											confirmModal: false,
										});
									}}>No</button>
								</div>
							</>,
					});
				}}
				className="button button-outlined"
			>
				Cancel
			</button>;

		if (isEdit) {
			let nonExclusiveSystemPresent = false;

			bottomButton =
				<button
					onClick={(e) => {
						if (nonExclusiveSystemPresent) {
							this.setState({
								confirmModal:        true,
								confirmModalContent:
									<>
										<p>Cannot delete slides that are assigned to systems outside this group.</p>
										<div className="confirm-modal-buttons">
											<button className="button-outlined" onClick={(e) => {
												this.setState({
													confirmModal: false,
												});
											}}>Ok</button>
										</div>
									</>,
							});
							return;
						}

						this.setState({
							confirmModal:        true,
							confirmModalContent:
								<>
									<p>Are you sure you want to delete this slide?</p>
									<div className="confirm-modal-buttons">
										<button className="button-outlined" onClick={(e) => {
											this.props.deleteSlide(this.props?.slideData?.slideID, this.props?.slideData?.slideDeckSlideID);
										}}>Yes</button>
										<button className="button" onClick={(e) => {
											this.setState({
												confirmModal: false,
											});
										}}>No</button>
									</div>
								</>,
						});
					}}
					className="button button-outlined"
				>
					<CustomIcon
						icon='trash'
					/>Delete
				</button>;
		}

		if (modalState === 'library') {
			return (
				<div className={style.slideshowModal}>
					<div className={style.libraryModalContainer}>
						<div className={style.top}>
							<div className={style.breadcrumbs}>
								<strong><span onClick={(e) => {
									this.setState({
										modalState: 'slide',
									});
								}}>Slide Details</span> {'>'} Library</strong>
							</div>
						</div>
						<LibraryModal
							app={app}
							accountUUID={this.props.accountUUID}
							slideshowState={this}
							handleSelectGalleryFile={this.handleSelectGalleryFile.bind(this)}
							handleSelectFolder={this.handleSelectFolder.bind(this)}
						/>
					</div>
				</div>
			);
		}

		let confirmModalJSX = '';
		if (confirmModal === true) {
			confirmModalJSX =
				<div className="confirm-modal-container">
					<div className="confirm-modal-content">
						{confirmModalContent}
					</div>
				</div>;
		}

		let downloadOverlay = '';
		if (this.state.downloading) {
			downloadOverlay = (
				<div className="confirm-modal-container">
					<div className="confirm-modal-content" style={{ width: '320px', textAlign: 'center' }}>
						<p>Downloading...</p>
						<div style={{ background: '#e6e6e6', borderRadius: 6, height: 12, width: '100%', overflow: 'hidden' }}>
							<div style={{ width: `${this.state.downloadProgress}%`, height: '100%', background: '#0078d4', transition: 'width 200ms ease' }} />
						</div>
						<div style={{ marginTop: 8, fontSize: 13 }}>{this.state.downloadProgress}%</div>
					</div>
				</div>
			);
		}

		return (
			<>
				<div className={style.slideshowModal}>
					{confirmModalJSX}
					{downloadOverlay}
					<div className={style.slideshowModalContainer}>
						<div className={style.column1}>
							<div className={style.sectionLabel}>Details</div>
							<div className={style.uploader}>
								{(modalState === 'url' || kind === 'html') ?
									<>
										{/* <div className={style.instructions}>
                                            <strong>URL</strong> (https required)
                                        </div> */}
										<div className={style.uploaderContainer}>
											<input
												value={filePath}
												id='modalURL'
												type='text'
												style={
													{
														width:           '100%',
														height:          '100%',
														border:          'none',
														backgroundColor: 'transparent',
													}
												}
												placeholder='Insert URL here (https mandatory)'
												onChange={(e) => {
													this.setState({
														filePath: e.target.value,
													});
												}}
												data-testing-info={buildTestData('input--iframe-file')}
											/>
										</div>
									</> :
									<div className={kind === 'folder' ? `${style.uploaderContainer} ${style.folderIconContainer}` : style.uploaderContainer}>
										{kind === 'folder' ?
											renderFolderIcon(150) :
											<>
												<Img
													id="modalImage"
													src={previewSrc}
													alt={filePath}
													{...(isEdit ? {
														role:        'button',
														tabIndex:    0,
														'aria-label': `Preview: ${downloadFileName || filePath}. Click to download`,
														style:       { cursor: 'pointer' },
														onClick:  (e) => {
															e.preventDefault();
															e.stopPropagation();
															this.openConfirmDownload(originalURL, downloadFileName);
														},
														onKeyDown: (e) => {
															if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32) {
																e.preventDefault();
																e.stopPropagation();
																this.openConfirmDownload(originalURL, downloadFileName);
															}
														},
													} : {
														style: { cursor: 'default', opacity: 0.6 },
													})}
												/>
											</>
										}
									</div>
								}
								<div className={style.uploaderFileName}>
									{resolution}
								</div>
								<div className={style.uploaderButtons}>
									{!isEdit ? (
										<>
											{allowSlideshowUrl &&
												<button
													onClick={(e) => {
														this.setState({
															kind:               'html',
															filePath:           '',
															file:               null,
															// URL slides always occupy one slot; clear any
															// folder-slide value so the disabled control
															// and the saved payload agree.
															folderSlots:        1,
															isLibrarySelection: false,
															previewSrc:         basePreviewSrc,
															modalState:         'url',
														});
													}}
													className={disabledForEdit}
													data-testing-info={buildTestData('button--url')}
												>
													<CustomIcon icon='globe' />URL
												</button>}
											<button
												onClick={(e) => {
													this.setState({
														previewSrc: basePreviewSrc,
														modalState: 'library',
														kind:       '',
														filePath:   '',
													});
												}}
												className={disabledForEdit}
												data-testing-info={buildTestData('button--library')}
											>
												<CustomIcon icon='book' />Library
											</button>
											<button
												onClick={(e) => {
													this.setState({
														kind:       '',
														filePath:   '',
														previewSrc: basePreviewSrc,
														modalState: 'slide',
													});
													document.getElementById('slideUploadButton').click();
												}}
												className={disabledForEdit}
												data-testing-info={buildTestData('button--uploadFile')}
											>
												<CustomIcon icon='cloud-upload-alt' />Upload File(s)
											</button>
										</>
									) : (
										<>
											<button
												onClick={(e) => {
													this.setState({
														previewSrc: basePreviewSrc,
														modalState: 'library',
													});
												}}
												className="button"
												data-testing-info={buildTestData('button--replaceLibrary')}
											>
												<CustomIcon icon='book' />Library
											</button>
											<button
												onClick={(e) => {
													document.getElementById('slideUploadButton').click();
												}}
												className="button"
												data-testing-info={buildTestData('button--replaceUpload')}
											>
												<CustomIcon icon='cloud-upload-alt' />Upload File(s)
											</button>
										</>
									)}
								</div>
								<input
									id="slideUploadButton"
									data-test-id="slideUploadInput"
									onChange={(e) => {
										this.handleImageUpload(e);
										e.target.value = '';
									}}
									accept={VALID_EXTENSIONS.join(',')}
									type='file'
								/>
							</div>
							<div className={style.numberPickersContainer}>
								{/* # of Slots */}
								<div className={`numberPicker ${style.numberPicker}`}>
									<div className={`label ${style.label}`}>
										<label># of Slots</label>
									</div>
									<div className="numberPickerContainer">
										<button
											onClick={(e) => {
												e.preventDefault();
												if (folderSlots > 1) {
													this.setState({
														folderSlots: folderSlots - 1,
													});
												}
											}}
											className={kind !== 'folder' ? 'button-disabled no-click' : 'button'}
											disabled={kind !== 'folder'}
										>-</button>
										<span>
											<input
												value={folderSlots}
												id='modalFolderSlots'
												type='number'
												placeholder='1'
												disabled={kind !== 'folder'}
												onChange={(e) => {
													if (kind !== 'folder') {
														return;
													}
													const value = e.target.value.trim();
													if (value === '' || isNaN(Number(value))) {
														this.setState({
															folderSlots: '',
														});
													} else {
														this.setState({
															folderSlots: Number(value),
														});
													}
												}}
												onBlur={(e) => {
													if (this.state.folderSlots === '' || this.state.folderSlots < 1) {
														this.setState({
															folderSlots: 1,
														});
													}
												}}
												data-testing-info={buildTestData('input--folderSlots')}
											/>
										</span>
										<button
											onClick={(e) => {
												e.preventDefault();
												this.setState({
													folderSlots: folderSlots + 1,
												});
											}}
											className={kind !== 'folder' ? 'button-disabled no-click' : 'button'}
											disabled={kind !== 'folder'}
										>+</button>
									</div>
								</div>
								{/* Order */}
								<div className={`numberPicker ${style.numberPicker}`}>
									<div className={`label ${style.label}`}>
										<label>Order</label>
									</div>
									<div className="numberPickerContainer">
										<button
											onClick={(e) => {
												e.preventDefault();
												if (order > 1) {
													this.setState({
														order: order - 1,
													});
												}
											}}
											className={'button'}
										>-</button>
										<span>
											<input
												value={order}
												id='modalOrder'
												type='number'
												placeholder='1'
												onChange={(e) => {
													const value = e.target.value.trim();
													if (value === '' || isNaN(Number(value))) {
														this.setState({
															order: '',
														});
													} else {
														this.setState({
															order: Number(value),
														});
													}
												}}
												onBlur={(e) => {
													if (this.state.order === '' || this.state.order < 1) {
														this.setState({
															order: 1,
														});
													}
												}}
												data-testing-info={buildTestData('input--order')}
											/>
										</span>
										<button
											onClick={(e) => {
												e.preventDefault();
												this.setState({
													order: order + 1,
												});
											}}
											className={'button'}
										>+</button>
									</div>
								</div>
								{/* Display Duration */}
								<div className={`numberPicker ${style.numberPicker}`}>
									<div className={`label ${style.label}`}>
										<label>Display Duration</label>
									</div>
									<div className="numberPickerContainer">
										<button
											onClick={(e) => {
												e.preventDefault();
												if (duration > 1) {
													this.setState({
														duration: duration - 1,
													});
												}
											}}
											className={durationButtonClass}
										>-</button>
										<span>
											<input
												value={Math.round(duration)}
												type="number"
												onChange={(e) => {
													if (!isNaN(Number(e.target.value))) {
														this.setState({
															duration: Number(e.target.value),
														});
													} else {
														console.warn('Invalid input', e);
													}
												}}
												onBlur={(e) => {
													if (this.state.duration < 1) {
														this.setState({
															duration: 1,
														});
													}
												}}
												disabled={durationButtonClass.includes('disabled')}
												data-testing-info={buildTestData('input--duration')}
											/>
										</span>
										<button
											onClick={(e) => {
												e.preventDefault();
												this.setState({
													duration: duration + 1,
												});
											}}
											className={durationButtonClass}
										>+</button>
									</div>
								</div>
							</div>
							{/* Description */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>Description</label>
								</div>
								<textarea
									value={description}
									id='modalDescription'
									readOnly={isLibrarySelection}
									disabled={isLibrarySelection}
									aria-disabled={isLibrarySelection}
									placeholder='Placeholder'
									style={isLibrarySelection ? {
										backgroundColor: '#f5f5f5',
										cursor:          'not-allowed',
										color:           '#666',
									} : {}}
									onChange={(e) => {
										if (isLibrarySelection) {
											return;
										}
										this.setState({
											description: e.target.value,
										});
									}}
									onBlur={(e) => {
										if (isLibrarySelection) return; // no-op when locked
										this.setState({
											description: e.target.value.trim(),
										});
									}}
									data-test-id="slideDescriptionInput"
									data-testing-info={buildTestData('input--description')}
								/>
							</div>
							{/* File Name (non-editable) */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>Name</label>
								</div>
								<input
									value={fileName}
									type='text'
									readOnly
									disabled
									style={{
										backgroundColor: '#f5f5f5',
										cursor:          'not-allowed',
									}}
									data-testing-info={buildTestData('input--filename-readonly')}
								/>
							</div>
							{/* File Size (non-editable) */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>File Size</label>
								</div>
								<input
									value={formatBytes(fileSize)}
									type='text'
									readOnly
									disabled
									style={{
										backgroundColor: '#f5f5f5',
										cursor:          'not-allowed',
									}}
									data-testing-info={buildTestData('input--filename-readonly')}
								/>
							</div>
							{/* File Name (non-editable) */}
							<div className={`text-small ${style.description}`}>
								<div className={`label ${style.label}`}>
									<label>Resolution</label>
								</div>
								<input
									value={resolution}
									type='text'
									readOnly
									disabled
									style={{
										backgroundColor: '#f5f5f5',
										cursor:          'not-allowed',
									}}
									data-testing-info={buildTestData('input--filename-readonly')}
								/>
							</div>
						</div>
						<div className={style.column2}>
							<div className={style.sectionLabel} ref={this.schedulingSectionRef}>Scheduling</div>
							<div className={style.scheduling}>
								<div className={style.contentToggle}>
									<input
										className='on-off on-off-label'
										type='checkbox'
										checked={scheduled}
										onChange={(e) => {
											const newScheduled = !scheduled;
											this.setState({
												scheduled: newScheduled,
											}, () => {
												if (newScheduled && this.schedulingSectionRef.current) {
													this.schedulingSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
												}
											});
										}}
										data-testing-info={buildTestData('input--checkbox--scheduling')}
									/> Use Scheduling
								</div>

								{scheduled && (
									<>
										<div className={`text-small ${style.description}`}>
											<div className={`label ${style.label}`}>
												<label>Active Dates</label>
											</div>
											<div className={`${style.datePicker} ${style.show}`}>
												<div className={style.startDate}>
													<DatePicker
														showIcon
														selected={formateDateForDatePicker(scheduling.start_date)}
														placeholderText="Active Now"
														minDate={new Date()}
														maxDate={scheduling.end_date ? Date.parse(scheduling.end_date) : null}
														showTimeSelect
														timeFormat="h:mm aa"
														timeIntervals={15}
														dateFormat="MM/dd/yyyy h:mm aa"
														onChange={(e) => {
															let formattedDate = formatDateForJSON(e);
															scheduling.start_date = formattedDate;
															this.setState({
																scheduling,
															});
														}}
														data-testing-info={buildTestData('input--startDate')}
													/>
												</div>
												<div className={style.endDate}>
													<DatePicker
														showIcon
														selected={formateDateForDatePicker(scheduling.end_date)}
														placeholderText="No Expiration"
														minDate={scheduling.start_date ? Date.parse(scheduling.start_date) : new Date()}
														minTime={
															scheduling.start_date && scheduling.end_date &&
															new Date(scheduling.start_date).toDateString() === new Date(scheduling.end_date).toDateString() ?
																new Date(scheduling.start_date) :
																new Date().setHours(0, 0, 0, 0)
														}
														maxTime={new Date().setHours(23, 59, 59, 999)}
														showTimeSelect
														timeFormat="h:mm aa"
														timeIntervals={15}
														dateFormat="MM/dd/yyyy h:mm aa"
														onChange={(e) => {
															// Validate that end date/time is after start date/time
															if (scheduling.start_date && e <= new Date(scheduling.start_date)) {
																// If end is not after start, set it to start + 15 minutes
																const newEndDate = new Date(new Date(scheduling.start_date).getTime() + 15 * 60000);
																scheduling.end_date = formatDateForJSON(newEndDate);
															} else {
																let formattedDate = formatDateForJSON(e);
																scheduling.end_date = formattedDate;
															}
															this.setState({
																scheduling,
															});
														}}
														data-testing-info={buildTestData('input--endDate')}
													/>
												</div>
												<button className={style.clearButton}
													onClick={() => {
														scheduling.start_date = null;
														scheduling.end_date = null;
														this.setState({
															scheduling,
														});
													}}
													data-testing-info={buildTestData('button--clearDates')}
												>Clear</button>
											</div>
											<SchedulingHelperText />
										</div>

										<div className={`text-small ${style.description}`}>
											<div className={`label ${style.label}`}>
												<label>Display Schedule</label>
											</div>
											<div className={style.schedulingDropdownContainer} ref={this.schedulingModeDropdownRef}>
												<div
													className={style.schedulingDropdownHeader}
													onClick={this.toggleSchedulingModeDropdown}
													data-testing-info={buildTestData('button--schedulingMode')}
												>
													<span className={style.schedulingDropdownHeaderText}>
														{getSchedulingModeDisplayText(schedulingMode)}
													</span>
													<CustomIcon
														icon={this.state.schedulingModeDropdownOpen ? 'caret-up' : 'caret-down'}
														className={style.schedulingDropdownCaret}
													/>
												</div>

												{this.state.schedulingModeDropdownOpen && (
													<div className={style.schedulingDropdownList}>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																// Recurrence data is left untouched here so switching back
																// restores it; save-time cleaning handles the '' mode.
																this.setState({
																	schedulingMode:             '',
																	schedulingModeDropdownOpen: false,
																});
															}}
															data-testing-info={buildTestData('option--all-days-active')}
														>
															<span
																className={style.schedulingDropdownItemLabel}
																style={getSchedulingPlaceholderStyle(schedulingMode)}
															>
																All Days Currently Active
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	schedulingMode:             'all-day-specific-days',
																	schedulingModeDropdownOpen: false,
																});
															}}
															data-testing-info={buildTestData('option--all-day-specific-days')}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show all day on specific days
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	schedulingMode:             'daily-time-range',
																	schedulingModeDropdownOpen: false,
																});
															}}
															data-testing-info={buildTestData('option--daily-time-range')}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show every day within specific time range
															</span>
														</div>
														<div
															className={style.schedulingDropdownItem}
															onClick={() => {
																this.setState({
																	schedulingMode:             'specific-days-with-times',
																	schedulingModeDropdownOpen: false,
																});
															}}
															data-testing-info={buildTestData('option--specific-days-with-times')}
														>
															<span className={style.schedulingDropdownItemLabel}>
																Show on specific days within specific time ranges per day
															</span>
														</div>
													</div>
												)}
											</div>
										</div>

										{schedulingMode === 'all-day-specific-days' && (
											<div className={`text-small ${style.description}`}>
												<div className={`label ${style.label}`}>
													<label>Recurrence: Days of Week</label>
												</div>
												<WeekdaySelector
													selectedDays={scheduling.days}
													onDayToggle={(day) => {
														return this.updateDays(day);
													}}
													idSuffix=""
												/>
											</div>
										)}

										{schedulingMode === 'daily-time-range' && (
											<div className={`text-small ${style.description}`}>
												<div className={`label ${style.label}`}>
													<label>Recurrence: Time Range</label>
												</div>
												<div className={`${style.timePicker} ${style.show}`}>
													<div className={style.startDate}>
														<DatePicker
															selected={formatTimeForPicker(scheduling.recurring_start_time)}
															placeholderText="12:00 AM"
															{...timePickerProps}
															onChange={(e) => {
																scheduling.recurring_start_time = handleStartTimeChange(e, scheduling.recurring_end_time);
																this.setState({
																	scheduling,
																});
															}}
															data-testing-info={buildTestData('input--recurringStartTime')}
														/>
													</div>
													<div className={style.endDate}>
														<DatePicker
															selected={formatTimeForPicker(scheduling.recurring_end_time)}
															placeholderText="11:59 PM"
															{...timePickerProps}
															onChange={(e) => {
																scheduling.recurring_end_time = handleEndTimeChange(e, scheduling.recurring_start_time);
																this.setState({
																	scheduling,
																});
															}}
															data-testing-info={buildTestData('input--recurringEndTime')}
														/>
													</div>
													<button className={style.clearButton}
														onClick={() => {
															scheduling.recurring_start_time = null;
															scheduling.recurring_end_time = null;
															this.setState({
																scheduling,
															});
														}}
														data-testing-info={buildTestData('button--clearRecurringTimes')}
													>Clear</button>
												</div>
											</div>
										)}

										{schedulingMode === 'specific-days-with-times' && (
											<>
												<div className={`text-small ${style.description}`}>
													<div className={`label ${style.label}`}>
														<label>Recurrence: Days of Week</label>
													</div>
													<WeekdaySelector
														selectedDays={scheduling.days}
														onDayToggle={(day) => {
															return this.updateDays(day);
														}}
														idSuffix="-times"
													/>
												</div>

												{(scheduling.days || []).length > 0 && (
													<div className={`text-small ${style.description}`} ref={this.timeRangesByDayRef}>
														<div className={`label ${style.label}`}>
															<label>Time Ranges by Day</label>
														</div>
														{(scheduling.days || []).sort((a, b) => {
															return a - b;
														}).map((dayIndex) => {
															const dayName = dayMap[dayIndex];
															const dayScheduling = scheduling.recurring_times_by_day?.[dayIndex] || {
																use_recurring_times: true,
																start_time:          null,
																end_time:            null,
															};

															return (
																<div key={dayIndex} className={`${style.timePicker} ${style.show}`}>
																	<span style={{
																		minWidth:   '45px',
																		fontWeight: '600',
																	}}>{dayName}:</span>
																	<div className={style.startDate}>
																		<DatePicker
																			selected={formatTimeForPicker(dayScheduling.start_time)}
																			placeholderText="12:00 AM"
																			{...timePickerProps}
																			onChange={(e) => {
																				const newScheduling = {
																					...scheduling,
																				};
																				if (!newScheduling.recurring_times_by_day) newScheduling.recurring_times_by_day = {};
																				if (!newScheduling.recurring_times_by_day[dayIndex]) newScheduling.recurring_times_by_day[dayIndex] = {
																					use_recurring_times: true,
																				};
																				const dayEnd = newScheduling.recurring_times_by_day[dayIndex]?.end_time;
																				newScheduling.recurring_times_by_day[dayIndex].start_time = handleStartTimeChange(e, dayEnd);
																				this.setState({
																					scheduling: newScheduling,
																				});
																			}}
																			data-testing-info={buildTestData(`input--recurringStartTime--${dayName}`)}
																		/>
																	</div>
																	<div className={style.endDate}>
																		<DatePicker
																			selected={formatTimeForPicker(dayScheduling.end_time)}
																			placeholderText="11:59 PM"
																			{...timePickerProps}
																			onChange={(e) => {
																				const newScheduling = {
																					...scheduling,
																				};
																				if (!newScheduling.recurring_times_by_day) newScheduling.recurring_times_by_day = {};
																				if (!newScheduling.recurring_times_by_day[dayIndex]) newScheduling.recurring_times_by_day[dayIndex] = {
																					use_recurring_times: true,
																				};
																				const dayStart = newScheduling.recurring_times_by_day[dayIndex]?.start_time;
																				newScheduling.recurring_times_by_day[dayIndex].end_time = handleEndTimeChange(e, dayStart);
																				this.setState({
																					scheduling: newScheduling,
																				});
																			}}
																			data-testing-info={buildTestData(`input--recurringEndTime--${dayName}`)}
																		/>
																	</div>
																	<button className={style.clearButton}
																		onClick={() => {
																			const newScheduling = {
																				...scheduling,
																			};
																			if (!newScheduling.recurring_times_by_day) newScheduling.recurring_times_by_day = {};
																			if (!newScheduling.recurring_times_by_day[dayIndex]) newScheduling.recurring_times_by_day[dayIndex] = {
																				use_recurring_times: true,
																				start_time:          null,
																				end_time:            null,
																			};
																			newScheduling.recurring_times_by_day[dayIndex].start_time = null;
																			newScheduling.recurring_times_by_day[dayIndex].end_time = null;
																			this.setState({
																				scheduling: newScheduling,
																			});
																		}}
																		data-testing-info={buildTestData(`button--clearRecurringTimes--${dayName}`)}
																	>Clear</button>
																</div>
															);
														})}
													</div>
												)}
											</>
										)}
									</>
								)}
							</div>
						</div>
					</div>

					<div className={style.bottom}>
						<div className={style.bottomInstructions}><strong>Image Format:</strong> .JPEG, .JPG and .PNG (Max: 10mb) <strong>  Movie Format:</strong>  .MP4 as H.264, WebM. (Max file size: 400 MB file size, Max Resolution: HD, and Max Framerate: 30fps)</div>
						<div className={style.bottomButtons}>
							{bottomButton}
							<button
								onClick={(e) => {
									e.preventDefault();
									if (!saveDisabled) {
										if (!this.isSaving) {
											this.isSaving = true;
											app.load(
												this.save
											);
										}
									}
								}}
								className={`button ${saveDisabled ? 'button-disabled no-click' : ''}`}
							>
								<CustomIcon icon='save' /><div>Save</div>
							</button>
						</div>
					</div>
				</div>

			</>
		);
	}
}

class LibraryModal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className={style.chonkyWrapper}>
				<ChonkyFileBrowser
					app={this.props.app}
					mode="select-image"
					readOnly={true}
					onSelectImage={(image) => {
						this.props.handleSelectGalleryFile(image);
					}}
					onSelectFolder={(folder) => {
						this.props.handleSelectFolder(folder);
					}}
					accountUUID={this.props.accountUUID}
				/>
			</div>
		);
	}
}

export default SlideModal;
